'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/with-modal.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _glamorous = require('glamorous');
var _propTypes = require('prop-types');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var withModal = function withModal(Component) {
  ModalWrapper.propTypes = {
    zIndex: _propTypes.number,
    position: _propTypes.string,
    left: _propTypes.number,
    right: _propTypes.number,
    children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func])
  };
  function ModalWrapper(_ref) {
    var zIndex = _ref.zIndex,
      position = _ref.position,
      left = _ref.left,
      right = _ref.right,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['zIndex', 'position', 'left', 'right', 'children']);
    return _react2.default.createElement(_glamorous.Div, {
      zIndex: zIndex,
      position: position,
      left: left,
      right: right,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22
      },
      __self: this
    }, _react2.default.createElement(Component, Object.assign({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 23
      },
      __self: this
    })));
  }
  return ModalWrapper;
};
exports.default = withModal;